/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportButtonRequest
 */
export interface ExportButtonRequest {
    /**
     * The list of Domain IDs to export buttons from
     * @type {Array<string>}
     * @memberof ExportButtonRequest
     */
    sourceDomainIds: Array<string>;
    /**
     * The ID of the Domain to copy settings from (optional)
     * @type {string}
     * @memberof ExportButtonRequest
     */
    sourceDomainPropertiesId?: string;
}

/**
 * Check if a given object implements the ExportButtonRequest interface.
 */
export function instanceOfExportButtonRequest(value: object): value is ExportButtonRequest {
    if (!('sourceDomainIds' in value) || value['sourceDomainIds'] === undefined) return false;
    return true;
}

export function ExportButtonRequestFromJSON(json: any): ExportButtonRequest {
    return ExportButtonRequestFromJSONTyped(json, false);
}

export function ExportButtonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportButtonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceDomainIds': json['sourceDomainIds'],
        'sourceDomainPropertiesId': json['sourceDomainPropertiesId'] == null ? undefined : json['sourceDomainPropertiesId'],
    };
}

export function ExportButtonRequestToJSON(json: any): ExportButtonRequest {
    return ExportButtonRequestToJSONTyped(json, false);
}

export function ExportButtonRequestToJSONTyped(value?: ExportButtonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceDomainIds': value['sourceDomainIds'],
        'sourceDomainPropertiesId': value['sourceDomainPropertiesId'],
    };
}

